<template>
  <div>
    <div class="box box-primary">
      <div class="box-header with-border">
        <h3 class="box-title">{{ $t("project.bank_accounts") }}</h3>
      </div>

      <div class="box-body">
        <button
          @click="showModalBankAccount()"
          type="button"
          class="btn btn-default"
        >
          {{ $t("project.create_account") }}
        </button>
        <div class="row">
          <div
            class="col-xs-12"
            v-for="(account, index) in project_bank_accounts"
            :key="index"
          >
            <div class="account-header">
              <h4 style="display:inline-block;">
                {{ $t("project.account") }}: {{ account.bank_account_no }} - {{ account.bank_account_name }}
              </h4>
              <h4 style="display:inline-block;color:blue;">
                {{ account.is_active ? "-" + ` ${$t("project.active")}` : "" }}
              </h4>
              <button
                @click="showMessBank(account)"
                style="margin-right: 100px"
                type="button"
                class="btn btn-default"
              >
                {{ $t("project.usedAccount") }}
              </button>
              <button
                type="button"
                class="btn btn-default"
                @click="onCollapse(account)"
                data-toggle="collapse"
                :data-target="`#${account.id}`"
              >
                {{ $t("common.expand_btn") }}
              </button>
              <div :id="`${account.id}`" class="collapse">
                <div class="row account-visible-settings">
                  <div class="col-xs-12 form-horizontal">
                    <div class="form-group">
                      <label class="col-sm-2 col-md-2 col-lg-2">{{
                        $t("project.bank_account_no")
                      }}</label>
                      <div class="col-sm-6 col-md-6 col-lg-6">
                        <input
                          class="form-control"
                          type="text"
                          :placeholder="$t('project.bank_account_no')"
                          v-model="account.bank_account_no"
                        />
                      </div>
                    </div>
                  </div>
                  <div class="col-xs-12 form-horizontal">
                    <div class="form-group">
                      <label class="col-sm-2 col-md-2 col-lg-2">{{
                        $t("project.bankCode")
                      }}</label>
                      <div class="col-sm-6 col-md-6 col-lg-6">
                        <lte-select2
                          :options="utilBankList"
                          @change="onSelectUtilsBank"
                          :defaultSelected="
                            account.bank_code ? account.bank_code.id : null
                          "
                        >
                        </lte-select2>
                        <!-- <input class="form-control" type="text" :placeholder="'Mã Ngân Hàng'" v-model="account.bank_code.bank_name"> -->
                      </div>
                    </div>
                  </div>
                  <div class="col-xs-12 form-horizontal">
                    <div class="form-group">
                      <label class="col-sm-2 col-md-2 col-lg-2">{{
                        $t("project.branch")
                      }}</label>
                      <div class="col-sm-6 col-md-6 col-lg-6">
                        <input
                          class="form-control"
                          type="text"
                          :placeholder="$t('project.branch')"
                          v-model="account.bank_other_details"
                        />
                      </div>
                    </div>
                  </div>
                  <div class="col-xs-12 form-horizontal">
                    <div class="form-group">
                      <label class="col-sm-2 col-md-2 col-lg-2">{{
                        $t("project.bank_account_name")
                      }}</label>
                      <div class="col-sm-6 col-md-6 col-lg-6">
                        <input
                          class="form-control"
                          type="text"
                          :placeholder="$t('project.bank_account_name')"
                          v-model="account.bank_account_name"
                        />
                      </div>
                    </div>
                  </div>
                  <div class="col-xs-12 form-horizontal">
                    <div class="form-group">
                      <label class="col-sm-2 col-md-2 col-lg-2">{{
                        $t("project.bank_transferring_content")
                      }}</label>
                      <div class="col-sm-6 col-md-6 col-lg-6">
                        <input
                          class="form-control"
                          type="text"
                          :placeholder="$t('project.bank_transferring_content')"
                          v-model="account.bank_transferring_content"
                        />
                      </div>
                    </div>
                  </div>
                  <div class="col-xs-12 form-horizontal">
                    <div class="form-group">
                      <label class="col-sm-2 col-md-2 col-lg-2">{{
                        $t("project.bank_contact_us")
                      }}</label>
                      <div class="col-sm-6 col-md-6 col-lg-6">
                        <input
                          class="form-control"
                          type="text"
                          :placeholder="$t('project.bank_contact_us')"
                          v-model="account.bank_contact_us"
                        />
                      </div>
                    </div>
                    <button
                      type="button"
                      class="btn btn-labeled btn-success pull-right"
                      @click="onSaveBankAccount(account)"
                      v-if="
                        has_perm('update_project_setting') ||
                          GET_ACCOUNT_DATA.id == 1
                      "
                    >
                      <span class="btn-label">
                        <i class="glyphicon glyphicon-ok"></i>
                      </span>
                      {{ $t("common.save") }}
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- Modal Component -->
      <div class="modal fade" id="modal-add-bank-account">
        <div class="modal-dialog">
          <div class="modal-content">
            <div class="modal-header">
              <button
                type="button"
                class="close"
                data-dismiss="modal"
                aria-label="Close"
              >
                <span aria-hidden="true">&times;</span>
              </button>
              <h1 class="modal-title">{{ $t("project.add_bank_account") }}</h1>
            </div>
            <div class="modal-body">
              <b-form>
                <!-- Bank account no -->
                <b-form-group
                  label-size="sm"
                  label-for="input-sm"
                  :label="$t('project.bank_account_no')"
                >
                  <div class="form-group">
                    <div>
                      <input
                        v-model="bankAccountNo"
                        :placeholder="$t('project.enter_bank_account_no')"
                        class="form-control"
                      />
                    </div>
                  </div>
                </b-form-group>
                <!-- Bank code -->
                <b-form-group
                  label-size="sm"
                  label-for="input-sm"
                  :label="$t('project.bankCode')"
                >
                  <div class="form-group">
                    <lte-select2
                      :options="utilBankList"
                      @change="onSelectUtilsBank"
                    >
                    </lte-select2>
                  </div>
                </b-form-group>
                <!-- Bank other details -->
                <b-form-group
                  label-size="sm"
                  label-for="input-sm"
                  :label="$t('project.branch')"
                >
                  <div class="form-group">
                    <div>
                      <input
                        v-model="bankOtherDetails"
                        :placeholder="$t('project.enterBranch')"
                        class="form-control"
                      />
                    </div>
                  </div>
                </b-form-group>
                <!-- Bank account name -->
                <b-form-group
                  label-size="sm"
                  label-for="input-sm"
                  :label="$t('project.bank_account_name')"
                >
                  <div class="form-group">
                    <div>
                      <input
                        v-model="bankAccountName"
                        :placeholder="$t('project.enter_bank_account_name')"
                        class="form-control"
                        style="z-index:0"
                      />
                    </div>
                  </div>
                </b-form-group>
                <!-- Bank transferring content -->
                <b-form-group
                  label-size="sm"
                  label-for="input-sm"
                  :label="$t('project.bank_transferring_content')"
                >
                  <div class="form-group">
                    <div>
                      <input
                        v-model="bankTransferringContent"
                        :placeholder="
                          $t('project.enter_bank_transferring_content')
                        "
                        class="form-control"
                      />
                    </div>
                  </div>
                </b-form-group>
                <!-- Bank contact us -->
                <b-form-group
                  label-size="sm"
                  label-for="input-sm"
                  :label="$t('project.bank_contact_us')"
                >
                  <div class="form-group">
                    <div>
                      <input
                        v-model="bankContactUs"
                        :placeholder="$t('project.enter_bank_contact_us')"
                        class="form-control"
                      />
                    </div>
                  </div>
                </b-form-group>
              </b-form>
            </div>
            <div class="modal-footer">
              <!-- <button
              type="button"
              class="btn btn-default pull-left"
              data-dismiss="modal"
            >{{$t('user.password_modal[0].btn[2]')}}</button>-->
              <button
                type="button"
                v-if="
                  has_perm('update_project_setting') || GET_ACCOUNT_DATA.id == 1
                "
                @click="createBankAccount"
                class="btn btn-primary pull-left"
              >
                {{ $t("common.save") }}
              </button>
            </div>
          </div>
          <!-- /.modal-content -->
        </div>
        <!-- /.modal-dialog -->
      </div>
      <!-- /.modal -->
    </div>

    <div class="modal fade" id="modal-projectBank">
      <div class="modal-dialog">
        <div class="modal-content" id="modal-content-projectBank">
          <div class="modal-header">
            <button
              type="button"
              class="close"
              data-dismiss="modal"
              aria-label="Close"
            >
              <span aria-hidden="true">&times;</span>
            </button>
            <h4 class="modal-title">
              {{ $t("ProjectGeneralSettings.project_seting_title") }}
            </h4>
          </div>
          <div class="modal-body">
            <p>
              {{ $t("ProjectGeneralSettings.project_account") }}
              {{ $t("project.account") }} {{ onShowMessBank.id }}
            </p>
            {{ $t("ProjectGeneralSettings.bank_account_no") }}:
            {{ onShowMessBank.bank_account_no }}
            {{ $t("ProjectGeneralSettings.bank_name") }}:
            {{ onShowMessBank.bank_code && onShowMessBank.bank_code.bank_name }}
          </div>
          <div class="modal-footer">
            <button
              type="button"
              class="btn btn-default pull-left"
              data-dismiss="modal"
            >
              {{ $t("common.cancel") }}
            </button>
            <button
              type="button"
              class="btn btn-primary btn-green"
              @click="usedBankAccount"
            >
              {{ $t("common.confirm") }}
            </button>
          </div>
        </div>
      </div>
    </div>

    <lte-core-alert
      v-for="snackbar in GET_SNACK_BAR"
      :key="snackbar.id"
      :item="snackbar"
    ></lte-core-alert>
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import Select2 from "@/components/LTESelect2Input.vue";
import LTECoreAlert from "@/components/LTESnackBar.vue";
import utils from '@/lib/utils';

export default {
  name: "ProjectBankAccounts",
  props: {
    items: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      project_bank_accounts: [],
      isCollapse: false,
      bankAccountNo: "",
      bankAccountName: "",
      bankTransferringContent: "",
      bankContactUs: "",
      bankOtherDetails: "",
      bankAccountCodeId: 0,
      indexZ: -1,
      utilBankList: [],
      onShowMessBank: ""
    };
  },
  watch: {
    items: function() {
      this.initialize();
    }
  },
  computed: {
    ...mapGetters([
      "GET_SNACK_BAR",
      "GET_ACCOUNT_DATA"
    ])
  },
  methods: {
    ...mapActions([
      "SAVE_PROJECTBANKCONFIG",
      "SUCCESS_TOAST",
      "GET_PROJECT_DETAIL",
      "ERROR_TOAST",
      "CREATE_PROJECT_BANK_TRANSFER",
      "ON_SHOW_TOAST",
      "GET_LIST_AVAILABLE_BANKS"
    ]),
    has_perm: function(perm) {
      return utils.has_perm(this.GET_ACCOUNT_DATA, perm);
    },
    onSelectUtilsBank: function(item) {
      this.bankAccountCodeId = item.id;
    },
    getProjectBankInfo: function() {
      this.GET_PROJECT_DETAIL({ id: utils.getProjectSession() }).then(
        function(res) {
          let projData = res.data
          this.project_bank_accounts = [];
          for (let i = 0, size = projData.projectbankaccounts.length; i < size; i++) {
            projData.projectbankaccounts[i]["isCollapse"] = false;
            this.project_bank_accounts.push(projData.projectbankaccounts[i]);
          }
        }.bind(this)
      );
    },
    createBankAccount: function() {
      if (
        this.validateFormBankTransfer(
          this.bankAccountNo,
          this.bankAccountName,
          this.bankTransferringContent,
          this.bankContactUs,
          this.bankOtherDetails
        )
      ) {
        let filter = {
          bankAccountNo: this.bankAccountNo,
          bankAccountName: this.bankAccountName,
          bankTransferringContent: this.bankTransferringContent,
          bankContactUs: this.bankContactUs,
          bankOtherDetails: this.bankOtherDetails,
          bankAccountCodeId: this.bankAccountCodeId
        };
        this.CREATE_PROJECT_BANK_TRANSFER(filter)
          .then(
            function(res) {
              this.getProjectBankInfo();
              $("#modal-add-bank-account").modal("hide");
              this.SUCCESS_TOAST();
            }.bind(this)
          )
          .catch(
            function(error) {
              if (
                !utils.isNull(error.response.data.already_exist) &&
                error.response.data.already_exist
              ) {
                this.ON_SHOW_TOAST({
                  message: this.$t("project.existBankAccount"),
                  styleType: "danger"
                });
              } else {
                $("#modal-add-bank-account").modal("hide");
                this.ERROR_TOAST();
              }
            }.bind(this)
          );
      }
    },
    showModalBankAccount: function() {
      $("#modal-add-bank-account").modal("show");
    },
    initialize: function() {
      this.project_bank_accounts = this.items;
    },
    validateFormBankTransfer: function(
      accountNo,
      accountName,
      bankTransferringContent,
      contactUs,
      bankOtherDetails
    ) {
      if (accountNo === "") {
        this.ON_SHOW_TOAST({
          message: this.$t("project.validAccountNo"),
          styleType: "danger"
        });
        return false;
      } else if (!utils.isNumeric(accountNo)) {
        this.ON_SHOW_TOAST({
          message: this.$t("project.validAccountNoIsNumber"),
          styleType: "danger"
        });
        return false;
      } else if (bankOtherDetails == "") {
        this.ON_SHOW_TOAST({
          message: this.$t("project.validBankOtherDetails"),
          styleType: "danger"
        });
      } else if (accountName === "") {
        this.ON_SHOW_TOAST({
          message: this.$t("project.validAccountName"),
          styleType: "danger"
        });
        return false;
      } else if (bankTransferringContent === "") {
        this.ON_SHOW_TOAST({
          message: this.$t("project.validBankTransferringContent"),
          styleType: "danger"
        });
        return false;
      } else if (contactUs === "") {
        this.ON_SHOW_TOAST({
          message: this.$t("project.validBankContact"),
          styleType: "danger"
        });
        return false;
      } else {
        return true;
      }
    },
    onSaveBankAccount: function(account) {
      this.waitingLoading(true);
      let data = {
        bank_account_no: account.bank_account_no,
        bank_account_name: account.bank_account_name,
        bank_transferring_content: account.bank_transferring_content,
        bank_contact_us: account.bank_contact_us,
        bank_other_details: account.bank_other_details,
        bank_code_id: this.bankAccountCodeId
      };
      if (
        this.validateFormBankTransfer(
          account.bank_account_no,
          account.bank_account_name,
          account.bank_transferring_content,
          account.bank_contact_us,
          account.bank_other_details
        )
      ) {
        this.SAVE_PROJECTBANKCONFIG({
          id: account.id,
          data: data,
          isUsedBankAccount: "False"
        })
          .then(
            function() {
              this.SUCCESS_TOAST();
            }.bind(this)
          )
          .catch(
            function(error) {
              if (
                !utils.isNull(error.response.data.already_exist) &&
                error.response.data.already_exist
              ) {
                this.ON_SHOW_TOAST({
                  message: this.$t("project.existBankAccount"),
                  styleType: "danger"
                });
              } else {
                this.ERROR_TOAST();
              }
            }.bind(this)
          );
      }
    },
    waitingLoading: function(bol) {
      this.isLoading = bol;
    },
    onCollapse: function(account) {
      account.isCollapse = !account.isCollapse;
    },
    showMessBank(bank_item) {
      this.onShowMessBank = bank_item;
      $("#modal-projectBank").modal("show");
    },
    usedBankAccount: function() {
      $("#modal-projectBank").modal("hide");
      this.SAVE_PROJECTBANKCONFIG({
        id: this.onShowMessBank.id,
        isUsedBankAccount: "True"
      })
        .then(
          //{id:id, isUsedBankAccount: "True"}
          function() {
            this.getProjectBankInfo();
            this.SUCCESS_TOAST();
          }.bind(this)
        )
        .catch(
          function() {
            this.ERROR_TOAST();
          }.bind(this)
        );
    }
  },
  created() {
    this.GET_LIST_AVAILABLE_BANKS().then(
      function(res) {
        let data = res.data.response;
        this.utilBankList = data;
      }.bind(this)
    );
    this.getProjectBankInfo();
  },
  mounted() {
    this.initialize();
  },
  components: {
    "lte-core-alert": LTECoreAlert,
    "lte-select2": Select2
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
@media (min-width: 768px) {
  .modal-dialog {
    width: 800px;
  }
  #modal-content-projectBank {
    width: 600px;
    margin-left: 100px;
  }
}

hr.devide_account {
  border-top: 1px solid #eee;
  margin-left: 1px;
  margin-right: 1px;
}

.account-header {
  position: relative;
  padding: 20px 110px 0 0;
  border-top: 1px solid #e5e5e5;
  margin-left: 1px;
  margin-right: 1px;
}

.account-header button {
  position: absolute;
  top: 20px;
  right: 6px;
  min-width: 80px;
}

.account-visible-settings {
  border: 1px solid #e5e5e5;
  padding: 10px 10px;
  margin-left: 0px;
  margin-right: 0px;
}
</style>



// WEBPACK FOOTER //
// src/views/Project/ProjectBankAccounts.vue